import { useEffect, useState } from "react";
import { api } from "../lib/api";
export function LegalFirms() {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [name, setName] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [saving, setSaving] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({ name: "", contactPerson: "", mobile: "", email: "" });
    function load() {
        api.get("/legal-firms").then((r) => setItems(r.items)).catch(() => setError("Couldn't load legal firms."));
    }
    useEffect(load, []);
    async function create() {
        const errs = {};
        if (!name.trim())
            errs.name = "Firm name is required.";
        if (email && !/^\S+@\S+\.\S+$/.test(email))
            errs.email = "Enter a valid email address.";
        setFieldErrors(errs);
        if (Object.keys(errs).length)
            return;
        setSaving(true);
        setError(null);
        try {
            await api.post("/legal-firms", {
                name: name.trim(),
                contactPerson: contactPerson.trim() || undefined,
                mobile: mobile.trim() || undefined,
                email: email.trim() || undefined,
            });
            setName("");
            setContactPerson("");
            setMobile("");
            setEmail("");
            setShowForm(false);
            load();
        }
        catch (e) {
            setError(e?.code === "forbidden" ? "You don't have permission to add legal firms." : "Couldn't save this firm.");
        }
        finally {
            setSaving(false);
        }
    }
    async function toggleActive(firm) {
        try {
            await api.put(`/legal-firms/${firm.id}/active`, { isActive: !firm.isActive });
            load();
        }
        catch {
            setError("Couldn't update this firm's status.");
        }
    }
    function startEdit(firm) {
        setEditingId(firm.id);
        setEditForm({ name: firm.name, contactPerson: firm.contactPerson ?? "", mobile: firm.mobile ?? "", email: firm.email ?? "" });
    }
    async function saveEdit(id) {
        if (!editForm.name.trim())
            return;
        setError(null);
        try {
            await api.put(`/legal-firms/${id}`, {
                name: editForm.name.trim(),
                contactPerson: editForm.contactPerson.trim() || undefined,
                mobile: editForm.mobile.trim() || undefined,
                email: editForm.email.trim() || undefined,
            });
            setEditingId(null);
            load();
        }
        catch (e) {
            setError(e?.code === "forbidden" ? "You don't have permission to edit legal firms." : "Couldn't save changes.");
        }
    }
    return (<div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: "1.6rem", margin: 0 }}>Legal Firms</h1>
        <button onClick={() => setShowForm((v) => !v)} style={btnStyle}>{showForm ? "Cancel" : "+ New Firm"}</button>
      </div>

      {error && <div style={{ color: "var(--st-risk)", marginBottom: 12 }}>{error}</div>}

      {showForm && (<div style={{ background: "var(--surface)", border: "1px solid var(--line-soft)", borderRadius: 10, padding: 16, marginBottom: 18 }}>
          <div className="lg-stack" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10 }}>
            <div>
              <input placeholder="Firm name *" value={name} onChange={(e) => setName(e.target.value)} style={inputStyle}/>
              {fieldErrors.name && <div style={errText}>{fieldErrors.name}</div>}
            </div>
            <input placeholder="Contact person" value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} style={inputStyle}/>
            <input placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} style={inputStyle}/>
            <div>
              <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle}/>
              {fieldErrors.email && <div style={errText}>{fieldErrors.email}</div>}
            </div>
          </div>
          <button onClick={create} disabled={saving} style={{ ...btnStyle, marginTop: 12 }}>Save Firm</button>
        </div>)}

      <div style={{ background: "var(--surface)", border: "1px solid var(--line-soft)", borderRadius: 10, overflow: "hidden" }}>
        {items.map((f) => editingId === f.id ? (<div key={f.id} style={{ padding: "12px 18px", borderTop: "1px solid var(--line-soft)" }}>
              <div className="lg-pair" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 }}>
                <input value={editForm.name} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} placeholder="Name" style={inputStyle}/>
                <input value={editForm.contactPerson} onChange={(e) => setEditForm({ ...editForm, contactPerson: e.target.value })} placeholder="Contact person" style={inputStyle}/>
                <input value={editForm.mobile} onChange={(e) => setEditForm({ ...editForm, mobile: e.target.value })} placeholder="Mobile" style={inputStyle}/>
                <input value={editForm.email} onChange={(e) => setEditForm({ ...editForm, email: e.target.value })} placeholder="Email" style={inputStyle}/>
              </div>
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <button onClick={() => setEditingId(null)} style={linkBtn}>Cancel</button>
                <button onClick={() => saveEdit(f.id)} style={btnStyle}>Save</button>
              </div>
            </div>) : (<div key={f.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderTop: "1px solid var(--line-soft)" }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: "0.88rem" }}>{f.name}</div>
                <div className="mono" style={{ fontSize: "0.72rem", color: "var(--ink-faint)" }}>{f.mobile ?? "—"} {f.email ? `· ${f.email}` : ""}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span className="mono" style={{ fontSize: "0.68rem", fontWeight: 600, padding: "3px 9px", borderRadius: 5, background: f.isActive ? "var(--st-open-bg)" : "var(--surface-2)", color: f.isActive ? "var(--st-open)" : "var(--ink-faint)" }}>
                  {f.isActive ? "ACTIVE" : "INACTIVE"}
                </span>
                <button onClick={() => startEdit(f)} style={linkBtn}>Edit</button>
                <button onClick={() => toggleActive(f)} style={linkBtn}>{f.isActive ? "Deactivate" : "Reactivate"}</button>
              </div>
            </div>))}
        {items.length === 0 && !error && <div style={{ padding: 24, textAlign: "center", color: "var(--ink-faint)", fontSize: "0.85rem" }}>No legal firms yet.</div>}
      </div>
    </div>);
}
const inputStyle = { border: "1px solid var(--line)", borderRadius: 8, padding: "8px 10px", fontSize: "0.82rem", fontFamily: "inherit", width: "100%" };
const btnStyle = { background: "var(--brand)", color: "#fff", fontWeight: 600, fontSize: "0.82rem", padding: "8px 16px", borderRadius: 8, border: "none", cursor: "pointer" };
const linkBtn = { border: "1px solid var(--line)", background: "var(--surface)", color: "var(--ink-soft)", fontWeight: 600, fontSize: "0.75rem", padding: "5px 10px", borderRadius: 7, cursor: "pointer" };
const errText = { color: "var(--st-risk)", fontSize: "0.72rem", marginTop: 3 };
